// ErrorNotification.jsx
import { useDispatch, useSelector } from 'react-redux'
import Toaster from 'src/components/helperComponents/Toaster'
import { HIDE_ERROR } from 'src/redux/errorReducer'
import { describeError } from 'src/util/bulkImport'

const ErrorNotification = () => {
  const isOpen = useSelector(state => state.errorReducer.isOpen)
  const error = useSelector(state => state.errorReducer.error)

  const dispatch = useDispatch()

  function handleClose() {
    dispatch({ type: HIDE_ERROR })
  }
  // Callers dispatch anything from a plain string to a raw axios Error, and an
  // object reaching Toaster's `{msg}` throws "Objects are not valid as a React
  // child" — so everything is reduced to a string here.
  let msg = ''
  if (Array.isArray(error?.data?.errors)) {
    msg = error.data.errors.map(x => x.msg).join('\n ')
  } else if (error) {
    msg = describeError(error, 'Something went wrong. Please try again.')
  }
  return (
    <>
      {isOpen && error && (
        <Toaster msg={msg} severity="error" onClose={handleClose} />
      )}
    </>
  )
}

export default ErrorNotification
